import React,{ Component } from "react";
//import { Container } from "react-bootstrap";
import About from './components/About';
import './App.css';

import Projects from "./components/Projects";
import Contact from './components/Contact';
import Main from './components/Main';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

class App extends Component{
  render(){

    return (
      <Router>
        <div>
        <Switch>
          <Route exact path='/' component={Main}></Route>
          <Route  path='/about'>
            <About/>
          </Route> 
          <Route  path='/projects' component={Projects}></Route>
          <Route path='/contact' component={Contact}></Route>
        </Switch>
        </div>

     
      </Router>
  );

  }
}
  


export default App;
